module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG1002-995de9d3dd0c22d25bbacbe2540a4998.png";